import BasePointerHandler from '@/modules/three/common/curve/interactiveSpline/BasePointerHandler.js';
import RaycasterClass from '@modules/three/common/raycast';
import { threeStore } from '@modules/three/store/threeStore';
import SplineControlPoint from './SplineControlPoint';

export default class DraggingHandler extends BasePointerHandler {
  private selectedPoint: SplineControlPoint | null = null;
  private neighborsSnap = false;
  private snapToNewPoint = false;
  private snapThreshold = 1;

  onPointerDown(selectedPoint: SplineControlPoint): void {
    this.selectedPoint = selectedPoint;
    threeStore.getState().rootState.controls.enabled = false;
    this.interactiveSpline.hideOthers();
  }

  onPointerMove(event: PointerEvent): void {
    if (!this.selectedPoint) return;
    const intersection = RaycasterClass.getFirstObjectIntersection(event, this.interactiveSpline.parentMesh);
    if (intersection) {
      this.selectedPoint.position.copy(intersection.point);
      this.interactiveSpline.updateLine();
      this.snapNeighbors();
    }
  }

  // eslint-disable-next-line no-unused-vars
  onPointerUp(_event: PointerEvent): void {
    if (!this.selectedPoint) return;
    this.selectedPoint = null;
    threeStore.getState().rootState.controls.enabled = true;
    this.interactiveSpline.showAll();
  }

  snapNeighbors(): void {
    if (!this.selectedPoint || !this.neighborsSnap) return;

    const snappedPoint = this.selectedPoint.getSnappedPoint();
    if (snappedPoint) {
      snappedPoint.position.copy(this.selectedPoint.position);
      snappedPoint.getInteractiveSpline().updateLine();
      return;
    }

    if (!this.snapToNewPoint) return;

    let closestDistance = Infinity;
    let closestPoint: SplineControlPoint | null = null;
    for (const other of this.interactiveSpline.getOtherInstances()) {
      const tempClosest = other.getClosestSplineControlPoint(this.selectedPoint.position);
      if (other === this.interactiveSpline) continue;
      if (tempClosest && tempClosest.getSnappedPoint() === null && tempClosest.position.distanceTo(this.selectedPoint.position) < closestDistance) {
        closestDistance = tempClosest.position.distanceTo(this.selectedPoint.position);
        closestPoint = tempClosest;
      }
    }
    if (closestPoint && closestDistance < this.snapThreshold) {
      closestPoint.position.copy(this.selectedPoint.position);
      closestPoint.getInteractiveSpline().updateLine();
      this.selectedPoint.setSnappedPoint(closestPoint);
      closestPoint.setSnappedPoint(this.selectedPoint);
    }
  }
}
